import Lara from "@/presets/lara";

export const SessionDeadlineModalPresets = {
  ...Lara,
  dialog: {
    ...Lara.dialog,
    header: {
      class: [
        // Flexbox & Alignment
        "flex items-center justify-between",
        "shrink-0",

        // Spacing
        "px-5",
        "py-3",

        // Shape
        "border-t-0",
        "h-[50px]",

        // Colors
        "bg-teal-accent",
        "font-bold",
        "text-sm",
        "!text-university-primary",
      ],
    },
    content: ({ state, instance }) => ({
      class: [
        // Spacing
        "px-6",
        "pb-8",
        "pt-6",

        // Colors & Text
        "bg-surface-0",
        "text-surface-700",
        "text-black",
        "text-base",
        "bg-white",

        // Overflow handling
        "overflow-y-auto",
      ],
    }),
  },
};
